module.exports = __webpack_public_path__ + "img/saudi-arabia.2dd9486f.svg";